
const formReset = (formWrap, form) => {
    if(formWrap.classList.contains('loading')){
        formWrap.classList.remove('loading');
    }
    if(formWrap.querySelector('.thom-form--response')){
        formWrap.querySelector('.thom-form--response').classList.add('is-hidden');
    }
    form.reset();
};

export { formReset };

